import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllFinancialYears, getITDepreciationReportGrid } from '../../api/ReportsAPI/itDepreciationReportAPI';

const err = (e, fallback) => e?.Message || e?.message || fallback;

export const fetchITDepFinancialYears = createAsyncThunk('itDepreciationReport/fetchYears', async (_, { rejectWithValue }) => {
    try { const res = await getAllFinancialYears(); return res?.Data || []; }
    catch (e) { return rejectWithValue(err(e, 'Failed to fetch financial years')); }
});

export const fetchITDepreciationReport = createAsyncThunk('itDepreciationReport/fetchReport', async (fYear, { rejectWithValue }) => {
    try { const res = await getITDepreciationReportGrid(fYear); return res?.Data || []; }
    catch (e) { return rejectWithValue(err(e, 'Failed to fetch IT depreciation report')); }
});

const initialState = {
    years: [], yearsLoading: false,
    data: [], dataLoading: false, dataError: null,
};

const itDepreciationReportSlice = createSlice({
    name: 'itDepreciationReport',
    initialState,
    reducers: {
        clearITDepreciationReport: (s) => { s.data = []; s.dataError = null; },
        resetITDepreciationReport: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchITDepFinancialYears.pending, (s) => { s.yearsLoading = true; })
            .addCase(fetchITDepFinancialYears.fulfilled, (s, a) => { s.yearsLoading = false; s.years = a.payload; })
            .addCase(fetchITDepFinancialYears.rejected, (s) => { s.yearsLoading = false; });

        builder
            .addCase(fetchITDepreciationReport.pending, (s) => { s.dataLoading = true; s.dataError = null; })
            .addCase(fetchITDepreciationReport.fulfilled, (s, a) => { s.dataLoading = false; s.data = a.payload; })
            .addCase(fetchITDepreciationReport.rejected, (s, a) => { s.dataLoading = false; s.dataError = a.payload; });
    },
});

export const { clearITDepreciationReport, resetITDepreciationReport } = itDepreciationReportSlice.actions;

export const selectITDepYears        = (s) => s.itDepreciationReport.years;
export const selectITDepYearsLoading = (s) => s.itDepreciationReport.yearsLoading;
export const selectITDepData         = (s) => s.itDepreciationReport.data;
export const selectITDepDataLoading  = (s) => s.itDepreciationReport.dataLoading;
export const selectITDepDataError    = (s) => s.itDepreciationReport.dataError;

export default itDepreciationReportSlice.reducer;
